import React from 'react';

const GoogleSearchAd = ({
    finalUrl,
    headline1,
    headline2,
    description,
    sitelinks
}) => {
    let cleanUrl = finalUrl?.trim() || "brightmediasolution.com";
    if (cleanUrl.startsWith('http://')) cleanUrl = cleanUrl.substring(7);
    if (cleanUrl.startsWith('https://')) cleanUrl = cleanUrl.substring(8);
    
    const displayHeadline1 = headline1?.trim() || "Premier Digital Agency";
    const displayHeadline2 = headline2?.trim() || "Bright Media Solution";
    const displayDesc = description?.trim() || "Scale your business with our customized digital marketing, social media management, and web development services.";
    
    const displaySitelinks = Array.isArray(sitelinks) && sitelinks.length
      ? sitelinks
      : ["Contact Us", "Our Services", "Request Quote", "Case Studies"];

    return (
        <div style={{
            width: '100%',
            maxWidth: '520px',
            border: '1px solid #dadce0',
            borderRadius: '8px',
            padding: '16px',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontSize: '14px',
            backgroundColor: '#ffffff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            textAlign: 'left'
        }}>
            {/* Header info */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                <span style={{ 
                    fontSize: '11px', 
                    fontWeight: '700', 
                    color: '#202124',
                    backgroundColor: '#f1f3f4',
                    padding: '2px 6px',
                    borderRadius: '3px'
                }}>
                    Sponsored
                </span>
            </div>

            {/* Breadcrumb URL */}
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', color: '#202124', marginBottom: '4px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                <div style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    backgroundColor: '#f1f3f4',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                    fontSize: '9px',
                    color: '#5f6368'
                }}>
                    <i className="fa fa-globe" />
                </div>
                <span>https://{cleanUrl}</span>
                <i className="fa fa-caret-down" style={{ marginLeft: '4px', color: '#70757a', fontSize: '10px' }} />
            </div>

            {/* Blue headline title */}
            <a 
                href={finalUrl?.startsWith('http') ? finalUrl : `https://${cleanUrl}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ 
                    color: '#1a0dab', 
                    textDecoration: 'none', 
                    fontSize: '20px', 
                    fontWeight: '400',
                    lineHeight: '1.3',
                    marginBottom: '4px', 
                    display: 'block',
                    cursor: 'pointer'
                }}
                onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
            >
                {displayHeadline1} | {displayHeadline2}
            </a>

            {/* Description */}
            <div style={{ 
                color: '#4d5156', 
                fontSize: '14px', 
                lineHeight: '1.58',
                marginBottom: '12px',
                wordBreak: 'break-word'
            }}>
                {displayDesc}
            </div>

            {/* Sitelinks Grid */}
            {displaySitelinks.length > 0 && (
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(2, 1fr)', 
                    gap: '12px 16px',
                    borderTop: '1px solid #f1f3f4',
                    paddingTop: '12px',
                    marginTop: '8px'
                }}>
                    {displaySitelinks.slice(0, 4).map((link, index) => (
                        <div key={index} style={{ display: 'flex', flexDirection: 'column' }}>
                            <span 
                                style={{
                                    color: '#1a0dab',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    cursor: 'pointer',
                                    textDecoration: 'none'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                            >
                                {link}
                            </span>
                            <span style={{ fontSize: '12px', color: '#70757a', marginTop: '2px' }}>
                                Find out more information about {link.toLowerCase()}.
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GoogleSearchAd;
